<div class="app-info__container">
    <img class="app-info__logo" appImgFallback [src]="appLogoUrl" loading="lazy" />
    <a class="app-info__resource-link" [href]="href" [title]="params.Name" target="_blank"> {{params.Name}}</a>
</div>